import { apiInvoker } from "../lib/apiInvoker";
import { API_URLS } from "../lib/apiUrls";

export const signIn = (payload) => apiInvoker.post(API_URLS.AUTH.SIGNIN, payload);

export const signUp = (payload) => apiInvoker.post(API_URLS.AUTH.SIGNUP, payload);

export const forgotPassword = (payload) =>
  apiInvoker.post(API_URLS.AUTH.FORGOT_PASSWORD, payload);

export const otpVerification = (payload) =>
  apiInvoker.post(API_URLS.AUTH.VERIFY_OTP, payload);

export const resendOTP = (payload) =>
  apiInvoker.post(API_URLS.AUTH.RESEND_OTP, payload);

export const resetPassword = (payload) =>
  apiInvoker.post(API_URLS.AUTH.RESET_PASSWORD, payload);

export const getCurrentUser = (payload) =>
  apiInvoker.get(API_URLS.AUTH.ME, payload);

export const updateProfile = (payload) =>
  apiInvoker.put(API_URLS.USER.UPDATE_PROFILE(), payload);

export const googleOAuthCallback = (code, state) =>
  apiInvoker.get(`${API_URLS.AUTH.GOOGLE_CALLBACK}?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`);

export const googleOAuthLogin = () =>
  apiInvoker.get(API_URLS.AUTH.GOOGLE_LOGIN);

export const getGoogleStatus = () =>
  apiInvoker.get(API_URLS.AUTH.GOOGLE_CONNECT_STATUS);

export const googleDisconnect = () =>
  apiInvoker.post(API_URLS.AUTH.GOOGLE_DISCONNECT);

export const getCreatorProfile = () =>
  apiInvoker.get(API_URLS.USER.GET_CREATOR_PROFILE());

export const deleteAccount = () =>
  apiInvoker.delete(API_URLS.USER.DELETE_ACCOUNT());